const PACKAGES_LIMIT = 50;
const PACKAGE_WEIGHT_LIMIT = 150;
const DEFAULT_DELIVERY_TIME = 5;
const USA_STATES_LIST = [{
  code: 'AL',
  name: 'Alabama'
}, {
  code: 'AK',
  name: 'Alaska'
}, {
  code: 'AS',
  name: 'American Samoa'
}, {
  code: 'AZ',
  name: 'Arizona'
}, {
  code: 'AR',
  name: 'Arkansas'
}, {
  code: 'CA',
  name: 'California'
}, {
  code: 'CO',
  name: 'Colorado'
}, {
  code: 'CT',
  name: 'Connecticut'
}, {
  code: 'DE',
  name: 'Delaware'
}, {
  code: 'DC',
  name: 'District of Columbia'
}, {
  code: 'FM',
  name: 'Federated States of Micronesia'
}, {
  code: 'FL',
  name: 'Florida'
}, {
  code: 'GA',
  name: 'Georgia'
}, {
  code: 'GU',
  name: 'Guam'
}, {
  code: 'HI',
  name: 'Hawaii'
}, {
  code: 'ID',
  name: 'Idaho'
}, {
  code: 'IL',
  name: 'Illinois'
}, {
  code: 'IN',
  name: 'Indiana'
}, {
  code: 'IA',
  name: 'Iowa'
}, {
  code: 'KS',
  name: 'Kansas'
}, {
  code: 'KY',
  name: 'Kentucky'
}, {
  code: 'LA',
  name: 'Louisiana'
}, {
  code: 'ME',
  name: 'Maine'
}, {
  code: 'MH',
  name: 'Marshall Islands'
}, {
  code: 'MD',
  name: 'Maryland'
}, {
  code: 'MA',
  name: 'Massachusetts'
}, {
  code: 'MI',
  name: 'Michigan'
}, {
  code: 'MN',
  name: 'Minnesota'
}, {
  code: 'MS',
  name: 'Mississippi'
}, {
  code: 'MO',
  name: 'Missouri'
}, {
  code: 'MT',
  name: 'Montana'
}, {
  code: 'NE',
  name: 'Nebraska'
}, {
  code: 'NV',
  name: 'Nevada'
}, {
  code: 'NH',
  name: 'New Hampshire'
}, {
  code: 'NJ',
  name: 'New Jersey'
}, {
  code: 'NM',
  name: 'New Mexico'
}, {
  code: 'NY',
  name: 'New York'
}, {
  code: 'NC',
  name: 'North Carolina'
}, {
  code: 'ND',
  name: 'North Dakota'
}, {
  code: 'MP',
  name: 'Northern Mariana Islands'
}, {
  code: 'OH',
  name: 'Ohio'
}, {
  code: 'OK',
  name: 'Oklahoma'
}, {
  code: 'OR',
  name: 'Oregon'
}, {
  code: 'PW',
  name: 'Palau'
}, {
  code: 'PA',
  name: 'Pennsylvania'
}, {
  code: 'PR',
  name: 'Puerto Rico'
}, {
  code: 'RI',
  name: 'Rhode Island'
}, {
  code: 'SC',
  name: 'South Carolina'
}, {
  code: 'SD',
  name: 'South Dakota'
}, {
  code: 'TN',
  name: 'Tennessee'
}, {
  code: 'TX',
  name: 'Texas'
}, {
  code: 'UT',
  name: 'Utah'
}, {
  code: 'VT',
  name: 'Vermont'
}, {
  code: 'VI',
  name: 'Virgin Islands'
}, {
  code: 'VA',
  name: 'Virginia'
}, {
  code: 'WA',
  name: 'Washington'
}, {
  code: 'WV',
  name: 'West Virginia'
}, {
  code: 'WI',
  name: 'Wisconsin'
}, {
  code: 'WY',
  name: 'Wyoming'
}, {
  code: 'AA',
  name: 'Armed Forces Americas'
}, {
  code: 'AE',
  name: 'Armed Forces Africa'
}, {
  code: 'AE',
  name: 'Armed Forces Canada'
}, {
  code: 'AE',
  name: 'Armed Forces Europe'
}, {
  code: 'AE',
  name: 'Armed Forces Middle East'
}, {
  code: 'AP',
  name: 'Armed Forces Pacific'
}];
export const CANADA_STATES_LIST = [{
  name: 'Alberta',
  code: 'AB'
}, {
  name: 'British Columbia',
  code: 'BC'
}, {
  name: 'Manitoba',
  code: 'MB'
}, {
  name: 'New Brunswick',
  code: 'NB'
}, {
  name: 'Newfoundland and Labrador',
  code: 'NL'
}, {
  name: 'Northwest Territories',
  code: 'NT'
}, {
  name: 'Nova Scotia',
  code: 'NS'
}, {
  name: 'Nunavut',
  code: 'NU'
}, {
  name: 'Ontario',
  code: 'ON'
}, {
  name: 'Prince Edward Island',
  code: 'PE'
}, {
  name: 'Quebec',
  code: 'QC'
}, {
  name: 'Saskatchewan',
  code: 'SK'
}, {
  name: 'Yukon Territory',
  code: 'YT'
}];
export const UPS_GROUND = '03';
export let Carrier = /*#__PURE__*/function (Carrier) {
  Carrier["UPS"] = "UPS";
  Carrier["USPS"] = "USPS";
  Carrier["FEDEX"] = "FEDEX";
  Carrier["DHL"] = "DHL";
  Carrier["UNKNOWN"] = "UNKNOWN";
  return Carrier;
}({});
export const DHL_ALLOWED_SHIPPING_OPTIONS = {
  GND: 'GND',
  PLY: 'PLY'
};
export let FlatRatesTypes = /*#__PURE__*/function (FlatRatesTypes) {
  FlatRatesTypes["Domestic"] = "DomesticFlatRate";
  FlatRatesTypes["International"] = "InternationalFlatRate";
  FlatRatesTypes["Custom"] = "Custom";
  return FlatRatesTypes;
}({});
export const FLAT_RATES = {
  [FlatRatesTypes.Domestic]: {
    serviceCode: FlatRatesTypes.Domestic,
    name: 'Ground',
    description: ''
  },
  [FlatRatesTypes.International]: {
    serviceCode: FlatRatesTypes.International,
    name: 'Ground',
    description: ''
  },
  [FlatRatesTypes.Custom]: {
    serviceCode: FlatRatesTypes.Custom,
    name: 'Ground',
    description: ''
  }
};
const FULFILLMENT_CENTER = {
  ITEMS_PER_BOX: 20,
  PER_ADDITIONAL_BOX_PRICE: 450,
  OVER_COST_FOR_FIRST_BOX: 150,
  PER_QUANTITY_COST: 55
};
const MAX_USPS_FIRST_CLASS_15_99OZ = 15.999;
const MAX_USPS_FIRST_CLASS_3OZ = 3;
const MAX_USPS_FIRST_CLASS_6OZ = 6;
const MAX_USPS_FIRST_CLASS_12OZ = 12;
const MAX_FEDEX_GROUND_ECONOMY_144OZ = 144;
const CONVERTER_COEFFICIENT_LBS_TO_OZ = 16;
const COUNTRY_CODES = {
  AX: 'AX',
  AL: 'AL',
  DZ: 'DZ',
  AS: 'AS',
  AD: 'AD',
  AO: 'AO',
  AI: 'AI',
  AG: 'AG',
  AR: 'AR',
  AM: 'AM',
  AW: 'AW',
  AU: 'AU',
  AT: 'AT',
  AZ: 'AZ',
  BS: 'BS',
  BH: 'BH',
  BD: 'BD',
  BB: 'BB',
  BY: 'BY',
  BE: 'BE',
  BZ: 'BZ',
  BJ: 'BJ',
  BM: 'BM',
  BT: 'BT',
  BO: 'BO',
  BQ: 'BQ',
  BA: 'BA',
  BW: 'BW',
  BR: 'BR',
  VG: 'VG',
  BN: 'BN',
  BG: 'BG',
  BF: 'BF',
  BI: 'BI',
  KH: 'KH',
  CM: 'CM',
  CA: 'CA',
  IC: 'IC',
  CV: 'CV',
  KY: 'KY',
  CF: 'CF',
  TD: 'TD',
  CL: 'CL',
  CN: 'CN',
  CO: 'CO',
  CG: 'CG',
  CK: 'CK',
  CR: 'CR',
  HR: 'HR',
  CW: 'CW',
  CY: 'CY',
  CZ: 'CZ',
  CD: 'CD',
  DK: 'DK',
  DJ: 'DJ',
  DM: 'DM',
  DO: 'DO',
  EC: 'EC',
  EG: 'EG',
  SV: 'SV',
  EN: 'EN',
  GQ: 'GQ',
  ER: 'ER',
  EE: 'EE',
  ET: 'ET',
  FO: 'FO',
  FJ: 'FJ',
  FI: 'FI',
  FR: 'FR',
  GF: 'GF',
  PF: 'PF',
  GA: 'GA',
  GM: 'GM',
  GE: 'GE',
  DE: 'DE',
  GH: 'GH',
  GI: 'GI',
  GR: 'GR',
  GL: 'GL',
  GD: 'GD',
  GP: 'GP',
  GU: 'GU',
  GT: 'GT',
  GG: 'GG',
  GN: 'GN',
  GW: 'GW',
  GY: 'GY',
  HT: 'HT',
  HO: 'HO',
  HN: 'HN',
  HK: 'HK',
  HU: 'HU',
  IS: 'IS',
  IN: 'IN',
  ID: 'ID',
  IQ: 'IQ',
  IE: 'IE',
  IL: 'IL',
  IT: 'IT',
  CI: 'CI',
  JM: 'JM',
  JP: 'JP',
  JE: 'JE',
  JO: 'JO',
  KZ: 'KZ',
  KE: 'KE',
  KI: 'KI',
  XK: 'XK',
  KW: 'KW',
  KG: 'KG',
  LA: 'LA',
  LV: 'LV',
  LB: 'LB',
  LS: 'LS',
  LR: 'LR',
  LI: 'LI',
  LT: 'LT',
  LU: 'LU',
  MO: 'MO',
  MK: 'MK',
  MG: 'MG',
  MW: 'MW',
  MY: 'MY',
  MV: 'MV',
  ML: 'ML',
  MT: 'MT',
  MH: 'MH',
  MQ: 'MQ',
  MR: 'MR',
  MU: 'MU',
  MX: 'MX',
  FM: 'FM',
  MD: 'MD',
  MC: 'MC',
  MN: 'MN',
  ME: 'ME',
  MS: 'MS',
  MA: 'MA',
  MZ: 'MZ',
  MP: 'MP',
  NA: 'NA',
  NP: 'NP',
  NL: 'NL',
  NC: 'NC',
  NZ: 'NZ',
  NI: 'NI',
  NE: 'NE',
  NG: 'NG',
  NF: 'NF',
  NB: 'NB',
  NO: 'NO',
  OM: 'OM',
  PK: 'PK',
  PW: 'PW',
  PA: 'PA',
  PG: 'PG',
  PY: 'PY',
  PE: 'PE',
  PH: 'PH',
  PL: 'PL',
  PT: 'PT',
  PR: 'PR',
  QA: 'QA',
  RE: 'RE',
  RO: 'RO',
  RW: 'RW',
  WS: 'WS',
  SM: 'SM',
  SA: 'SA',
  SF: 'SF',
  SN: 'SN',
  RS: 'RS',
  SC: 'SC',
  SL: 'SL',
  SG: 'SG',
  SK: 'SK',
  SI: 'SI',
  SB: 'SB',
  ZA: 'ZA',
  KR: 'KR',
  ES: 'ES',
  LK: 'LK',
  C3: 'C3',
  UV: 'UV',
  KN: 'KN',
  LC: 'LC',
  SX: 'SX',
  VL: 'VL',
  VC: 'VC',
  SR: 'SR',
  SZ: 'SZ',
  SE: 'SE',
  CH: 'CH',
  TW: 'TW',
  TJ: 'TJ',
  TZ: 'TZ',
  TH: 'TH',
  TG: 'TG',
  TO: 'TO',
  TT: 'TT',
  TN: 'TN',
  TR: 'TR',
  TM: 'TM',
  TC: 'TC',
  TV: 'TV',
  UG: 'UG',
  UA: 'UA',
  AE: 'AE',
  GB: 'GB',
  US: 'US',
  UY: 'UY',
  VI: 'VI',
  UZ: 'UZ',
  VU: 'VU',
  VA: 'VA',
  VE: 'VE',
  VN: 'VN',
  WL: 'WL',
  WF: 'WF',
  YE: 'YE',
  ZM: 'ZM',
  ZW: 'ZW'
};

// ISO 3166-1 EL (Greece) => GR
export const COUNTRY_CODES_EU = {
  BE: 'BE',
  BG: 'BG',
  CZ: 'CZ',
  DK: 'DK',
  DE: 'DE',
  EE: 'EE',
  IE: 'IE',
  GR: 'GR',
  ES: 'ES',
  FR: 'FR',
  HR: 'HR',
  IT: 'IT',
  CY: 'CY',
  LV: 'LV',
  LT: 'LT',
  LU: 'LU',
  HU: 'HU',
  MT: 'MT',
  NL: 'NL',
  AT: 'AT',
  PL: 'PL',
  PT: 'PT',
  RO: 'RO',
  SI: 'SI',
  SK: 'SK',
  FI: 'FI',
  SE: 'SE'
  // UA: 'UA' uncomment in bright future
};

export const COUNTRY_CODES_EUROZONE = {
  AT: 'AT',
  BE: 'BE',
  CY: 'CY',
  EE: 'EE',
  FI: 'FI',
  FR: 'FR',
  DE: 'DE',
  GR: 'GR',
  IE: 'IE',
  IT: 'IT',
  LV: 'LV',
  LT: 'LT',
  LU: 'LU',
  MT: 'MT',
  NL: 'NL',
  PT: 'PT',
  SK: 'SK',
  SI: 'SI',
  ES: 'ES'
};
export const COUNTRIES_WITH_STATES = [COUNTRY_CODES.US, COUNTRY_CODES.CA];
export const COUNTRIES_WITH_ZIP_TRANSFORM = [COUNTRY_CODES.US];
export const PACKAGE_MAX_WEIGHT = 150;
const RATES_LIST_WITH_POSSIBLE_PRICE_CHANGES = [{
  first: '12',
  second: '02'
}];
export const USA_STATES_CODE_NAME_MAP = USA_STATES_LIST.reduce((acc, item) => {
  acc[item.code] = item.name;
  return acc;
}, {});
export { PACKAGES_LIMIT, PACKAGE_WEIGHT_LIMIT, DEFAULT_DELIVERY_TIME, USA_STATES_LIST, FULFILLMENT_CENTER, CONVERTER_COEFFICIENT_LBS_TO_OZ, MAX_USPS_FIRST_CLASS_12OZ, MAX_USPS_FIRST_CLASS_6OZ, MAX_USPS_FIRST_CLASS_3OZ, MAX_USPS_FIRST_CLASS_15_99OZ, MAX_FEDEX_GROUND_ECONOMY_144OZ, COUNTRY_CODES, RATES_LIST_WITH_POSSIBLE_PRICE_CHANGES };